import { BaseEntity, BaseDataSourceConstructorEntity } from '@base-entities';
import { AdvanceTemplateDataSource } from '../../data/data-sources';
import { AdvanceTemplateDataSourceRepository } from '../repositories';

export function makeAdvanceTemplateDataSource<E extends BaseEntity = BaseEntity>(
  params: BaseDataSourceConstructorEntity,
): AdvanceTemplateDataSourceRepository<E> {
  return new AdvanceTemplateDataSource<E>(params);
}
